{
    "DefaultSet_Standard_Reports": "Rapporti standard",
    "DefaultSet_Power_User_Reports": "Rapporti dei Power User",
    "DefaultSet_Contact_Centre_Reports": "Rapporti sui centri di contatto",
    "DefaultSet_Call_Centre_Reports": "Rapporti sui call center",
    "DefaultSet_SIP_Reports": "Rapporti SIP",
    "NAME": "ReportingDefaultReportSets",
    "DefaultSet_Enhanced_Call_Centre_Reports": "Rapporti migliorati sul call center",
    "DefaultSet_Call_Centre_Agent_Reports": "Rapporti sugli agenti del call center",
    "DefaultSet_Essentials_Reports_MST": "Rapporti standard CXA",
    "DefaultSet_Professional_Reports_MST": "Rapporti CXA non utilizzati",
    "DefaultSet_Call_Centre_Agent_Reports_MST": "Rapporti CXA Premium",
    "DefaultSet_Call_Center_Reports": "Rapporti sui call center",
    "DefaultSet_Enhanced_Call_Center_Reports": "Rapporti migliorati sul call center"
}